import { Injectable, signal } from '@angular/core';
import { Platform } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  public isCordova = signal<boolean>(false);
  public isAndroid = signal<boolean>(false);
  public isIOS     = signal<boolean>(false);
  public isIPhone  = signal<boolean>(false);
  public isIPAD    = signal<boolean>(false);
  public isTablet  = signal<boolean>(false);
  public isDesktop = signal<boolean>(false);

  constructor(private platform: Platform) {
    this.isCordova.set(this.platform.is('hybrid'));
    this.isAndroid.set(this.platform.is('android'));
    this.isIOS.set(this.platform.is('ios'));
    this.isIPhone.set(this.platform.is('iphone'));
    this.isIPAD.set(this.platform.is('ipad'));
    this.isTablet.set(this.platform.is('tablet'));
    this.isDesktop.set(this.platform.is('desktop'));
  }
}